var React = require('react');

function Brush (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.2145 20.783C7.12203 20.783 4.62573 23.2533 4.62573 26.3135C4.62573 28.7285 2.46475 30.0005 0.899902 30.0005C2.61378 32.2496 5.53856 33.6875 8.35155 33.6875C12.4686 33.6875 15.8032 30.3876 15.8032 26.3135C15.8032 23.2533 13.3069 20.783 10.2145 20.783ZM35.755 3.5095L33.2587 1.03922C32.5322 0.320259 31.3585 0.320259 30.632 1.03922L13.9403 17.5569L19.0633 22.6265L35.755 6.10883C36.4815 5.38987 36.4815 4.22847 35.755 3.5095Z","fill":"#4CC2D6"}));
}

Brush.defaultProps = {"viewBox":"0 0 37 34","fill":"none"};

module.exports = Brush;

Brush.default = Brush;
